<template>
  <div class="product-modify common-page">
    <!-- 面包屑 -->
    <a-breadcrumb>
      <a-breadcrumb-item>产品管理</a-breadcrumb-item>
      <a-breadcrumb-item>修改</a-breadcrumb-item>
    </a-breadcrumb>

    <!-- 设备信息 -->
    <section class="common-box">
      <div class="common-box-title">产品信息</div>
      <div class="common-box-body">
        <a-form :form="form">
          <a-row>
            <a-col :span="8">
              <a-form-item label="产品名称" v-bind="formItemLayout">
                <a-input
                  maxlength="64"
                  placeholder="请输入产品名称"
                  v-decorator="[
                    'name',
                    {
                      rules: [
                        {
                          required: true,
                          message: '请输入产品名称',
                          whitespace: true,
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item label="授权算法编号" v-bind="formItemLayout">
                <a-input-number
                  :min="0"
                  placeholder="请输入授权算法编号"
                  style="width: 100%"
                  v-decorator="[
                    'algorithmtype',
                    {
                      rules: [
                        { required: true, message: '请输入授权算法编号' },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item
                label="产品类型编号"
                extra="取值范围0~9"
                v-bind="formItemLayout"
              >
                <a-input-number
                  placeholder="请输入产品类型编号"
                  style="width: 100%"
                  :min="0"
                  :max="9"
                  v-decorator="[
                    'type',
                    {
                      rules: [
                        { required: true, message: '请输入产品类型编号' },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item label="描述" v-bind="formItemLayout">
                <a-textarea
                  maxlength="256"
                  placeholder="请输入描述"
                  :rows="4"
                  v-decorator="[
                    'description',
                    {
                      rules: [
                        {
                          required: false,
                          message: '请输入描述',
                          whitespace: true,
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </section>

    <!-- 产品功能 -->
    <section class="common-box">
      <div class="common-box-title">产品功能</div>
      <div class="common-box-body">
        <a-table
          :columns="columns_func"
          :rowKey="(record, index) => index"
          :dataSource="data_func"
          :pagination="false"
        >
          <!-- 功能名称 -->
          <template slot="id" slot-scope="text, record">
            <a-select
              v-if="record.editable"
              :value="text"
              @change="(e) => handleChange(e, record.index, 'id')"
              style="margin: -6px 0; width: 50%"
            >
              <a-select-option
                v-for="func in functions_select"
                :key="func.id"
                :value="func.id"
                :disabled="func.disabled"
                >{{ func.name }}</a-select-option
              >
            </a-select>
            <span v-else>{{ getFuncNameByID(text) }}</span>
          </template>

          <!-- 产品功能操作 -->
          <template slot="action" slot-scope="text, record">
            <template v-if="record.editable">
              <span v-if="record.isNew" class="cant-select">
                <a @click="saveRow(record)">添加</a>
                <a-divider type="vertical" />
                <a-popconfirm
                  title="是否要删除此行？"
                  @confirm="remove(record.index)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </span>
              <span v-else class="cant-select">
                <a @click="saveRow(record)">保存</a>
                <a-divider type="vertical" />
                <a @click="cancel(record.index)">取消</a>
              </span>
            </template>
            <span v-else class="cant-select">
              <a @click="toggle(record.index)">编辑</a>
              <a-divider type="vertical" />
              <a-popconfirm
                title="是否要删除此行？"
                @confirm="remove(record.index)"
              >
                <a>删除</a>
              </a-popconfirm>
            </span>
          </template>
        </a-table>
        <a-button
          style="width: 100%; margin-top: 16px; margin-bottom: 8px"
          type="dashed"
          icon="plus"
          @click="newMember"
          >新增功能</a-button
        >
      </div>
    </section>

    <!-- 扩展属性 -->
    <section class="common-box">
      <div class="common-box-title">扩展属性</div>
      <div class="common-box-body">
        <a-table
          :columns="columns_attr"
          :rowKey="(record, index) => index"
          :dataSource="data_attr"
          :pagination="false"
        >
          <!-- 类型 -->
          <template slot="type" slot-scope="text, record">
            <div v-if="record.editable">
              <a-checkbox
                v-model="record.p"
                @change="
                  (e) => handleChangeAttr(e.target.checked, record.index, 'p')
                "
              >
                p
              </a-checkbox>
              <a-checkbox
                v-model="record.u"
                @change="
                  (e) => handleChangeAttr(e.target.checked, record.index, 'u')
                "
              >
                u
              </a-checkbox>
            </div>
            <span v-else
              >{{ record.p || record.u ? "[" : "" }}{{ record.p ? "p" : ""
              }}{{ record.p && record.u ? ";" : "" }}{{ record.u ? "u" : ""
              }}{{ record.p || record.u ? "]" : "" }}</span
            >
          </template>
          <!-- 属性名 -->
          <template slot="key" slot-scope="text, record">
            <a-input
              maxlength="64"
              :allowClear="false"
              :value="text"
              v-if="record.isNew"
              style="margin: -6px 0"
              @change="
                (e) => handleChangeAttr(e.target.value, record.index, 'key')
              "
            />
            <span v-else>{{ text }}</span>
          </template>

          <!-- 属性英文名 -->
          <template slot="keyEn" slot-scope="text, record">
            <a-input
              maxlength="64"
              :allowClear="false"
              :value="text"
              v-if="record.isNew"
              style="margin: -6px 0"
              @change="
                (e) => handleChangeAttr(e.target.value, record.index, 'keyEn')
              "
            />
            <span v-else>{{ text }}</span>
          </template>

          <!-- 值 -->
          <template slot="value" slot-scope="text, record">
            <a-input
              maxlength="64"
              :allowClear="false"
              :value="text"
              v-if="record.editable"
              style="margin: -6px 0"
              @change="
                (e) => handleChangeAttr(e.target.value, record.index, 'value')
              "
            />
            <span v-else>{{ text }}</span>
          </template>

          <!-- 扩展属性操作 -->
          <template slot="action" slot-scope="text, record">
            <template v-if="record.editable">
              <span v-if="record.isNew" class="cant-select">
                <a @click="saveRowAttr(record)">添加</a>
                <a-divider type="vertical" />
                <a-popconfirm
                  title="是否要删除此行？"
                  @confirm="removeAttr(record.index)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </span>
              <span v-else class="cant-select">
                <a @click="saveRowAttr(record)">保存</a>
                <a-divider type="vertical" />
                <a @click="cancelAttr(record.index)">取消</a>
              </span>
            </template>
            <span v-else class="cant-select">
              <a @click="toggleAttr(record.index)">编辑</a>
              <a-divider type="vertical" />
              <a-popconfirm
                title="是否要删除此行？"
                @confirm="removeAttr(record.index)"
              >
                <a>删除</a>
              </a-popconfirm>
            </span>
          </template>
        </a-table>
        <a-button
          style="width: 100%; margin-top: 16px; margin-bottom: 8px"
          type="dashed"
          icon="plus"
          @click="newMemberAttr"
          >新增扩展属性</a-button
        >
      </div>
    </section>

    <section class="submit-box">
      <a-button type="primary" @click="submit" :loading="loading"
        >提交</a-button
      >
    </section>
  </div>
</template>

<script>
import axios from "axios";
import { queryProduct, queryFunctions, editProduct } from "../api/api";

const columns_func = [
  {
    title: "功能名称",
    dataIndex: "id",
    scopedSlots: { customRender: "id" },
    width: "50%",
  },
  {
    title: "操作",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
    width: "50%",
  },
];

const columns_attr = [
  {
    title: "类型",
    dataIndex: "type",
    scopedSlots: { customRender: "type" },
    width: "20%",
  },

  {
    title: "属性名",
    dataIndex: "key",
    scopedSlots: { customRender: "key" },
    width: "25%",
  },
  {
    title: "属性英文名",
    dataIndex: "keyEn",
    scopedSlots: { customRender: "keyEn" },
    width: "25%",
  },
  {
    title: "属性值",
    dataIndex: "value",
    scopedSlots: { customRender: "value" },
    width: "25%",
  },
  {
    title: "操作",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
    width: "25%",
  },
];

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

export default {
  name: "product-modify",

  data() {
    return {
      form: this.$form.createForm(this),
      formItemLayout,
      columns_func,
      columns_attr,
      data_func: [],
      data_attr: [],
      products: [],
      product: {},
      functions: [],
      loading: false,
    };
  },

  computed: {
    productID() {
      return parseInt(this.$route.query.productID);
    },

    functions_select() {
      let arr = [...this.functions];
      arr.forEach((item) => {
        item.disabled = false;
      });
      for (let i = 0; i < this.data_func.length; i++) {
        for (let j = 0; j < arr.length; j++) {
          if (this.data_func[i].id == arr[j].id) {
            arr[j].disabled = true;
          }
        }
      }
      return arr;
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    submit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true;
          let product = {
            id: this.productID,
            name: values.name,
            algorithmType: values.algorithmtype,
            type: values.type,
            description: values.description,
            functionsID: this.data_func.map((item) => item.id),
            extendedAttributes: this.data_attr.map((item) => {
              if (item.p == false && item.u == false) {
                return {
                  key: item.key,
                  key_en: item.keyEn,
                  value: item.value,
                };
              } else {
                let p = item.p == true ? "p" : "";
                let u = item.u == true ? "u" : "";
                let list = `[${p}${p&&u?';':''}${u}]`;
                item.type = list;
                return {
                  key: list + item.key,
                  key_en: item.keyEn,
                  value: item.value,
                };
              }
            }),
          };

          if (product.functionsID.length === 0) {
            this.$message.error("至少添加一个产品功能，且不可重复");
            this.loading = false;
            return;
          }

          if (
            this.data_func.some((item) => {
              return item.editable === true;
            })
          ) {
            this.$message.error("请点击【添加】【保存】产品功能");
            this.loading = false;
            return;
          }

          if (
            this.data_attr.some((item) => {
              return item.editable === true;
            })
          ) {
            this.$message.error("请点击【添加】【保存】扩展属性");
            this.loading = false;
            return;
          }

          editProduct(product)
            .then((res) => {
              if (res.error.code === 0) {
                this.$message.success("修改成功");
              }
              this.loading = false;
              this.$router.back();
              this.fetchData();
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log(err);
        }
      });
    },

    fetchData() {
      this.loading = true;
      axios
        .all([queryProduct(), queryFunctions()])
        .then(
          axios.spread((res1, res2) => {
            if (res1.error.code === 0) {
              this.products = res1.response ? res1.response.products : [];
              this.product = this.products.find(
                (item) => item.id === this.productID
              );

              this.form.setFieldsValue({
                name: this.product.name,
                algorithmtype: this.product.algorithmtype + "",
                type: this.product.type + "",
                description: this.product.description,
              });
              this.product.extendedAttributes.map((res) => {
                let newstr = res.key.split("]")[0].split("[")[1] || "";
                let a;
                if (newstr) {
                  a = newstr.split(";");
                }
                console.log(a, "a");
                if (a) {
                  a.map((reds) => {
                    console.log(reds=='p')
                    if (reds == "u") {
                      res.u = true;
                    }else
                    if (reds == "p") {
                      res.p = true;
                    }
                  });
                }else{
                      res.u = false;
                      res.p = false;

                }

                res.type = a;
                res.key = res.key.split("]")[1] || res.key;
              });
              console.log(this.product, "product");
              this.data_attr = this.product.extendedAttributes;
              this.data_attr.forEach((item, index) => {
                this.$set(item, "editable", false);
                this.$set(item, "index", index + 1);
              });
            }
            if (res2.error.code === 0) {
              this.functions = res2.response ? res2.response.functions : [];
              this.data_func = this.product.functionsID.map((item) => {
                return {
                  id: item,
                };
              });

              this.data_func.forEach((item, index) => {
                this.$set(item, "editable", false);
                this.$set(item, "index", index + 1);
              });
            }

            this.loading = false;
          })
        )
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    getFuncNameByID(id) {
      let obj = this.functions.find((item) => item.id === id);
      return obj && obj.name;
    },

    newMember() {
      const length = this.data_func.length;
      this.data_func.push({
        index:
          length === 0
            ? "1"
            : (parseInt(this.data_func[length - 1].index) + 1).toString(),
        id: "",
        editable: true,
        isNew: true,
      });
    },

    remove(index) {
      const newData = this.data_func.filter((item) => item.index !== index);
      this.data_func = newData;
    },

    saveRow(record) {
      const { index, id } = record;
      if (id === "") {
        this.$message.error("请填写完整信息");
        return;
      }
      const target = this.data_func.find((item) => item.index === index);
      target.editable = false;
      target.isNew = false;
    },

    toggle(index) {
      const target = this.data_func.find((item) => item.index === index);
      target._originalData = { ...target };
      target.editable = !target.editable;
    },

    cancel(index) {
      const target = this.data_func.find((item) => item.index === index);
      Object.keys(target).forEach((key) => {
        target[key] = target._originalData[key];
      });
      target._originalData = undefined;
    },

    handleChange(value, index, column) {
      const newData = [...this.data_func];
      const target = newData.find((item) => index === item.index);
      if (target) {
        target[column] = value;
        this.data_func = newData;
      }
    },

    newMemberAttr() {
      const length = this.data_attr.length;
      this.data_attr.push({
        index:
          length === 0
            ? "1"
            : (parseInt(this.data_attr[length - 1].index) + 1).toString(),
        key: "",
        keyEn: "",
        p: false,
        u: false,
        type: [],
        value: "",
        editable: true,
        isNew: true,
      });
    },

    removeAttr(index) {
      const newData = this.data_attr.filter((item) => item.index !== index);
      this.data_attr = newData;
    },

    saveRowAttr(record) {
      const { index, key, keyEn, value } = record;
      if (key === "" || keyEn === "" || value === "") {
        this.$message.error("请填写完整信息");
        return;
      }

      if (
        this.data_attr.filter(
          (item) => item.key.replace(/\s*/g, "") === key.replace(/\s*/g, "")
        ).length > 1
      ) {
        this.$message.error("存在重复的属性名");
        return;
      }

      const target = this.data_attr.find((item) => item.index === index);
      target.editable = false;
      target.isNew = false;
    },

    toggleAttr(index) {
      const target = this.data_attr.find((item) => item.index === index);
      target._originalData = { ...target };
      target.editable = !target.editable;
    },

    cancelAttr(index) {
      const target = this.data_attr.find((item) => item.index === index);
      Object.keys(target).forEach((key) => {
        target[key] = target._originalData[key];
      });
      target._originalData = undefined;
    },

    handleChangeAttr(value, index, column) {
      const newData = [...this.data_attr];
      const target = newData.find((item) => index === item.index);
      if (target) {
        target[column] = value;
        this.data_attr = newData;
      }
      console.log(newData,'newData')
    },
  },
};
</script>

<style lang="less" scoped>
.product-modify {
  margin-bottom: 56px;
}
</style>